import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from '../translate/en.json';
import translationAR from '../translate/ar.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources: {
      en: { translation: translationEN },
      ar: { translation: translationAR }
    },
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
